export default {
      id: "play-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "img/iconaf3563da19c86b00e5da1e83cc285294.svg#play",
      toString: function () {
        return this.url;
      }
    }